import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Layout, Space, Dropdown, Segmented, Row, Col, Tooltip } from "antd"
import Icon, { LogoutOutlined } from "@ant-design/icons"
import styled from "styled-components"
import { useNavigate } from "react-router-dom"
import useAuth from "hooks/useAuth"
import useLocales from "hooks/useLocales"
import { NAV_ITEM } from "configs"

import { ReactComponent as ProfileLogo } from "assets/icon/profile.svg"
import { ReactComponent as LanguageLogo } from "assets/icon/language.svg"
import { ReactComponent as HeaderMenu } from "assets/icon/header_menu.svg"

const { Header } = Layout

const Toolbar = styled.div({
  display: "flex",
  width: "100%",
  alignItems: "center",
  position: "relative",
  minHeight: "50px",
  height: "100%"
})

const Account = styled(Space)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-end",
  flexGrow: 1,
  cursor: "pointer"
})

export default function MainHeader({ collapsed, onCollapsed }) {
  const { user, logout } = useAuth()
  const { onChangeLang, translate, currentLang, allLang } = useLocales()
  const navigate = useNavigate()
  const [currentMenu, setCurrentMenu] = useState("")

  // Listen for pathname changes
  useEffect(() => {
    updateCurrentMenu()

    // Listen for popstate event (back/forward browser buttons)

    window.addEventListener("popstate", handlePopState)

    return () => {
      window.removeEventListener("popstate", handlePopState)
    }
  }, [])

  // Also listen for any location changes by checking pathname periodically
  useEffect(() => {
    updateCurrentMenu()
  }, [window.location.pathname])

  const handleLogout = async (data) => {
    try {
      await logout(data)
      navigate("/auth/login")
    } catch (error) {
      console.log(error)
    }
  }

  const handlePopState = () => {
    updateCurrentMenu()
  }

  const updateCurrentMenu = () => {
    const currentPath = window.location.pathname
    let menuItem = null

    // ค้นหาใน children ของ NAV_ITEM
    NAV_ITEM.forEach((group) => {
      if (group.children && !menuItem) {
        menuItem = group.children.find((item) => item.url === currentPath)
      }
    })

    if (menuItem) {
      setCurrentMenu(menuItem.title)
    } else {
      setCurrentMenu("")
    }
  }

  return (
    <Header>
      <Toolbar>
        <button
          className="header-current-menu"
          onClick={onCollapsed}
          style={{
            cursor: "pointer",
            border: "none",
            background: "transparent",
            padding: 0,
            display: "flex",
            alignItems: "center"
          }}
          type="button"
        >
          <Icon component={HeaderMenu} className="header-current-menu-icon" />
          <span className="header-current-menu-title">{translate(currentMenu)}</span>
        </button>

        <Account style={{ flexWrap: "wrap" }}>
          <Dropdown
            menu={{
              items: [
                {
                  label: (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <LanguageLogo style={{ marginRight: "8px" }} />
                        <span>{translate("s.switch-lang")}</span>
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Segmented
                          value={currentLang.value}
                          onChange={(value) => onChangeLang(value)}
                          size="small"
                          options={allLang.map((lang) => ({
                            value: lang.value,
                            label: lang.label
                          }))}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                    </div>
                  ),
                  key: "language"
                },
                {
                  label: (
                    <>
                      <LogoutOutlined style={{ marginRight: "10px" }} />
                      {translate("l.logout")}
                    </>
                  ),
                  key: "logout",
                  onClick: handleLogout
                }
              ]
            }}
            trigger={["click"]}
            className="account-dropdown"
            overlayStyle={{ minWidth: "250px" }}
          >
            <Row className="account-user-container" style={{ maxWidth: "200px" }}>
              <Col span={2} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
                <ProfileLogo className="account-user-avatar" />
              </Col>
              <Col span={22} align="center">
                <Row type="flex" align="middle" style={{ width: "100%" }}>
                  <Col span={24}>
                    <span className="account-user-name" title={`${user?.username}`}>
                      {`${user?.username}`}
                    </span>
                  </Col>
                  <Col span={24}>
                    <span className="account-user-name" title={`${user?.firstname} ${user?.lastname}`}>
                      {`${user?.firstname} ${user?.lastname}`}
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Dropdown>
        </Account>
      </Toolbar>
    </Header>
  )
}

MainHeader.propTypes = {
  collapsed: PropTypes.bool,
  onCollapsed: PropTypes.func
}
